import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { DeleteLotTransferItem, DeleteLotTransferItemVariables } from 'types/graphql';

const REMOVE_LOT_TRANSFER_ITEM = gql`
  mutation DeleteLotTransferItem($id: Int!) { deleteLotTransferItem(id: $id) { id } }
`;
export function useDeleteLotTransferItem() {
  const [mutate, { loading, error }] = useMutation<DeleteLotTransferItem, DeleteLotTransferItemVariables>(
    REMOVE_LOT_TRANSFER_ITEM
  );
  const remove = useCallback((id: number) => mutate({ variables: { id } }), [mutate]);
  return { remove, loading, error };
}
